import AppRecord from './AppRecord.js'

class Aif extends AppRecord {
}

export default Aif
